import axios from 'axios';
import * as endPoints from '../../Constants/Endpoints'

export function GetSite() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Site,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetShopId() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ShopId,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function CreateEmptySite() {
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Site,null,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function UpdateSiteLiveStatus(status) {
    const statusData = {
        status
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.SiteLive, statusData,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function UpdateTheme(
    themeId,
    logoFile,
    headerFile,
) {

    const formData = new FormData();
    formData.append("themeId", themeId)
    formData.append("logoFile", logoFile)
    formData.append("headerFile", headerFile)

    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.SiteTheme, formData,
    {
        headers: {
            "Content-Type" : ["multipart/form-data"],
        },

        withCredentials: true
    });
}

export function UpdateSiteTitle(title) {
    const siteTitle = {
        title
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.SiteTitle, siteTitle,
    {
        headers: {
            "Content-Type": "application/json",
        },

        withCredentials: true
    });
}

export function UpdateSiteSocials(facebook, instagram, twitter, tikTok, linkedIn) {
    const SiteSocialsDto = {
        facebook,
        instagram,
        twitter,
        tikTok,
        linkedIn
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.SiteSocials, SiteSocialsDto,
    {
        headers: {
            "Content-Type": "application/json",
        },

        withCredentials: true
    });
}

export function UpdateSiteSection(title, description, ids, sectionName, enabled) {
    const siteSection = {
        title,
        description,
        ids,
        sectionName,
        enabled
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.SiteSection, siteSection,
    {
        headers: {
            "Content-Type": "application/json",
        },

        withCredentials: true
    });
}

export function DisableSiteSection(name) {
    const siteSection = {
        name
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.DisableSiteSection, siteSection,
    {
        headers: {
            "Content-Type": "application/json",
        },

        withCredentials: true
    });
}

export function GetBarbers() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Barbers,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function UpdateSiteContactDetails(addressNumberName, addressFirstLine, addressSecondLine, addressCity, addressCounty, addressPostcode, phoneNumber, email) {
    const siteContactDetailsDto = {
        addressNumberName,
        addressFirstLine,
        addressSecondLine,
        addressCity,
        addressCounty,
        addressPostcode,
        phoneNumber,
        email
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.SiteContactDetails, siteContactDetailsDto,
    {
        headers: {
            "Content-Type": "application/json",
        },

        withCredentials: true
    });
}

export function UpdateSiteBusinessHours(ShowBusinessHours,
        SundayOpen,
        SundayClose,
        MondayOpen,
        MondayClose,
        TuesdayOpen,
        TuesdayClose,
        WednesdayOpen,
        WednesdayClose,
        ThursdayOpen,
        ThursdayClose,
        FridayOpen,
        FridayClose,
        SaturdayOpen,
        SaturdayClose) {

    const siteBusinessHoursDto = {
        ShowBusinessHours,
        SundayOpen,
        SundayClose,
        MondayOpen,
        MondayClose,
        TuesdayOpen,
        TuesdayClose,
        WednesdayOpen,
        WednesdayClose,
        ThursdayOpen,
        ThursdayClose,
        FridayOpen,
        FridayClose,
        SaturdayOpen,
        SaturdayClose
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.SiteBusinessHours, siteBusinessHoursDto,
    {
        headers: {
            "Content-Type": "application/json",
        },

        withCredentials: true
    });
}

export function DeleteImage(imageType) {
    return axios.delete(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.DeleteImage,
    {
        params: { imageType },
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetServices() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Services,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

// export function getCroppedImg(imageSrc, croppedAreaPixels) {
//   return new Promise((resolve) => {
//     const image = new Image();
//     image.src = imageSrc;
//     image.onload = () => {
//       const canvas = document.createElement('canvas');
//       canvas.width = croppedAreaPixels.width;
//       canvas.height = croppedAreaPixels.height;
//       const ctx = canvas.getContext('2d');
//       ctx.drawImage(
//         image,
//         croppedAreaPixels.x,
//         croppedAreaPixels.y,
//         croppedAreaPixels.width,
//         croppedAreaPixels.height,
//         0,
//         0,
//         croppedAreaPixels.width,
//         croppedAreaPixels.height
//       );
//       canvas.toBlob((blob) => {
//         const reader = new FileReader();
//         reader.readAsDataURL(blob);
//         reader.onloadend = () => resolve(reader.result)

//         // const url = URL.createObjectURL(blob);
//         // resolve(url); // You can return the blob too for backend
//       }, 'image/jpeg');
//     };
//   });
// }


// imageSrc: dataURL or object URL of the original image
// croppedAreaPixels: from react-easy-crop onCropComplete
// options: { targetWidth, targetHeight, mime, quality }
export async function getCroppedImg(imageSrc, croppedAreaPixels, options = {}) {
  const {
    // sensible defaults: wide header and square logo
    targetWidth = 1600,
    targetHeight = Math.round(1600 * (180 / 370)), // ≈ 778 if using your 370:180 aspect
    mime = 'image/jpeg',        // use 'image/png' for logos
    quality = 0.9,              // 0.85–0.92 is a good range for photos
    returnPreviewDataURL = true // handy for UI preview
  } = options;

  // Load source
  const img = await new Promise((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve(i);
    i.onerror = reject;
    i.src = imageSrc;
  });

  const dpr = window.devicePixelRatio || 1;

  // High-DPI canvas to keep things crisp
  const canvas = document.createElement('canvas');
  canvas.width  = Math.round(targetWidth * dpr);
  canvas.height = Math.round(targetHeight * dpr);

  const ctx = canvas.getContext('2d');
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';

  // Source crop rectangle (from react-easy-crop)
  const { x, y, width, height } = croppedAreaPixels;

  // Draw from source crop → scaled destination
  ctx.drawImage(
    img,
    x, y, width, height,    // source rect
    0, 0, canvas.width, canvas.height // dest rect (scaled to target)
  );

  // Downscale the HiDPI canvas back to CSS pixels if you want
  // (Not strictly required if you just use the Blob for upload.)
  // For best results we keep the DPR pixels in the Blob.

  // Export Blob
  const blob = await new Promise((resolve) =>
    canvas.toBlob(resolve, mime, mime === 'image/jpeg' ? quality : undefined)
  );

  // Optional dataURL for preview in your UI
  let dataURL = null;
  if (returnPreviewDataURL) {
    dataURL = await new Promise((resolve) => {
      const r = new FileReader();
      r.onloadend = () => resolve(r.result);
      r.readAsDataURL(blob);
    });
  }

  // Wrap as a File if you want filename/content-type
  const file = new File([blob], `crop.${mime === 'image/png' ? 'png' : 'jpg'}`, { type: mime });

  return { blob, file, dataURL };
}
